import { Typography } from "antd";
import { useTranslation } from "react-i18next";

import { useInterventionSectionDatasetForm } from "@/modules/intervention/intervention-section-datasets";
import InterventionSectionEmpty from "@/modules/intervention/intervention-section-empty";

import { InterventionSectionForm } from "./intervention-section-form.component";

import "./intervention-section-form.style.less";

const { Title } = Typography;

export const InterventionSectionFormWrapper = () => {
  const { t } = useTranslation();
  const { template } = useInterventionSectionDatasetForm();

  return (
    <div className="intervention-section-form">
      {!template ? (
        <>
          <Title level={3} className="intervention-section-form-title">
            {t("global:datasetTypes.form")}
          </Title>
          <div className="intervention-section-form-content">
            <InterventionSectionEmpty type="form" />
          </div>
        </>
      ) : (
        <div className="intervention-section-form-content">
          <InterventionSectionForm />
        </div>
      )}
    </div>
  );
};
